<template>
  <div class="m-page">
    <div class="m-info-box">
      <div class="m-info-tit"><img src="@/assets/img/home/Group787.png" alt=""><span>审核意见</span></div>
      <div class="m-des">
        {{obj.examineComment||'无'}}
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    components: {},
    props:{
      obj:{
        type:Object,
        default: () => {}
      }
    },
    data () {
      return {
        msg: '你好'
      }
    },
    created () {

    },
    methods: {},
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  .m-page{
    .m-info-box{
      background: #ffffff;
      border-radius: 4px;
      padding: 15px 12px 0 12px;
      margin-top: 18px;
      .m-info-tit{
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        >img{
          width: 16px;
          height: 16px;
        }
        >span{
          color: #2B6CF9;
          font-weight: bold;
          margin-left: 3px;
        }
      }
    }
    .m-des{
      padding-bottom: 15px;
      font-size: 14px;
      color: #8D8F93;
      line-height: 20px;
    }
  }
</style>

